import { io } from "socket.io-client";
import * as Sentry from "@sentry/browser";
import { reactBridge } from "@medflyt/webapp-react/src/core";

/* @ngInject */
export function Socket($rootScope, Consts, $injector, $timeout, $state, DatabaseApi, SweetAlert, Storage, $window, toaster, notificationsService) {

    function init(loginResponse) {
        let authToken = loginResponse.authToken;
        let reconnectAttempts = 0;

        var socket = io(Consts.socketApi, {
            withCredentials: false
        });
        
        window.socket = socket;

        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible" && reconnectAttempts === 5) {
            reconnectAttempts = 4;
            socket.disconnect();
            socket.connect();
          }
        });

        socket.on('connect', function(){
            console.log('[socket.io] socket connected');
            socket.emit('auth', {token: authToken});
        });

        socket.on("disconnect", () => {
            $timeout(() => $rootScope.socketStatus = 'disconnected');
            console.log('[socket.io] socket disconnected');
        });

        socket.on('auth:error', async (error) => {
            $timeout(() => $rootScope.socketStatus = 'disconnected');

            if (reconnectAttempts === 5) {
                Sentry.captureException(error, {
                    tags: {
                        agencyId: $rootScope.agencyId,
                        agencyMemberId: $rootScope.agencyMemberId,
                        token: authToken
                    }
                });
                console.log('[socket.io] socket auth error', JSON.stringify(error));
                return;
            }

            if (reconnectAttempts > 0) {
                console.log(`[socket.io] socket auth error. Retrying in ${reconnectAttempts}s`, error);
                await new Promise(resolve => setTimeout(resolve, reconnectAttempts * 1000));
            }

            if (reconnectAttempts === 0) {
                console.log(`[socket.io] socket auth error.`, error);
            }

            await DatabaseApi.get("");
            reconnectAttempts++;

            socket.disconnect();

            const authTokenFromStorage = Storage.getObject('user').authToken;

            if (authTokenFromStorage) {
                authToken = authTokenFromStorage;
            }

            socket.connect();
        })

        socket.on('auth:done', function(){
            reconnectAttempts = 0;
            $timeout(() => $rootScope.socketStatus = 'connected');
            console.log('[socket.io] socket auth success');
        });

        socket.on('caregiver:online', function(data){
            $injector.get('caregiverAppStatusService').setOnline(data.caregiverId);
            $rootScope.$broadcast('caregiver_changed',{id: data.caregiverId});
        });

        socket.on('caregiver:offline', function(data){
            $injector.get('caregiverAppStatusService').setOffline(data.caregiverId);
            $rootScope.$broadcast('caregiver_changed',{id: data.caregiverId});
        });

        const suppressedEvents = new Set([
          "caregiver:online",
          "caregiver:offline"
        ]);

        socket.onAny((event, payload) => {
            if (suppressedEvents.has(event)) {
                return;
            }

            import.meta.env.PROD
                ? console.debug('[socket.io] event received', event, payload)
                : console.debug(
                    `[socket.io]%c event received %c ${event}`,
                    'color: #00aaff',
                    'color: #11d94d',
                    typeof payload === "string" ? JSON.parse(payload) : payload
                );
            
            reactBridge.dispatch("SOCKET_EVENT_RECEIVED", {
                type: event,
                payload: safeJsonParse(payload),
            });
        });

        socket.on('VisitUpdated', function(data){
            var parsedData = JSON.parse(data);
            $rootScope.$broadcast('visit_id_changed', {visitId: parsedData.visitId});
        });

        socket.on('ClusterUpdated', function(data){

            var parsedData = JSON.parse(data);
            parsedData = parsedData.cluster;
            var isChange = false;
            parsedData.visit1.assignedCoordinators.forEach(function (coordinator) {
                if(DatabaseApi.getReleventMemberIds().indexOf(coordinator) > -1) {
                    isChange = true;
                }
            });
            parsedData.visit2.assignedCoordinators.forEach(function (coordinator) {
                if(DatabaseApi.getReleventMemberIds().indexOf(coordinator) > -1) {
                    isChange = true;
                }
            });

            if(isChange) {
                DatabaseApi.clusterUpdated(parsedData);
            }

        });


        socket.on('ChatRoomUpdated', function(data){
            var parsedData = JSON.parse(data);
            DatabaseApi.getMessagesByIds(parsedData.chatRoomId, parsedData.chatRoomData,'socket')
                .then(function (res) {
                    if( res && res.id ) $rootScope.$broadcast('chat_room_updated', res);
                });
        });

        socket.on('CaregiversUpdated', function(data){
            var parsedData = JSON.parse(data);
            var isPending = !!(parsedData.caregiverData &&
                parsedData.caregiverData.status === 'JOIN_REQUEST');

            $injector.get('DatabaseApi')
                .caregiversChanged(parsedData.caregiverId, parsedData.caregiverData, isPending)
                ?.then(function () {
                    $rootScope.$broadcast('caregiver_changed',{id: parsedData.caregiverId});
                });
        });

        socket.on('ScheduledVisitEditRequestChange', function () {
            DatabaseApi.getVisitPendingEditRequests().then(function () {
                $rootScope.$broadcast('VisitPendingRequestsUpdated');
            });
            DatabaseApi.getVisitArchivedEditRequests().then(function () {
                $rootScope.$broadcast('VisitArchivedRequestsUpdated');
            });
        });

        socket.on('PatientUpdated', function (data) {
            var parsedData = JSON.parse(data);
            $rootScope.$broadcast('PatientUpdated', parsedData);
        });

        socket.on('PatientCostShareUpdated', function (data) {
            var parsedData = JSON.parse(data);
            $rootScope.$broadcast('PatientCostShareUpdated', parsedData);
        });

        socket.on('ScoreChanged', function(data){
          var parsedData = JSON.parse(data);
          if(parsedData.agencyMemberId === $rootScope.agencyMemberId){
                $rootScope.sweepScore = parsedData.points;
                if($rootScope.sweepScore < 0) $rootScope.sweepScore = 0;
            }
        });

        socket.on('general:reload', function(data){
            if(!data || data.id === $rootScope.agencyMemberId){
                Storage.softClear();
                $window.location.reload();
            }
        });

        socket.on('general:reload-pop', function(){


            SweetAlert.swal({
                title: "System Update Available",
                text: "Confirm Refresh",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, refresh",
                closeOnConfirm: true,
                closeOnCancel: true
            }, function (isConfirm) {
                if (isConfirm) {
                    Storage.softClear();
                    $window.location.reload();
                }
            });


        });

        socket.on('PatientAlertAdded', function (data) {
            $rootScope.$broadcast('PatientAlertAdded', data);
          });

        socket.on('disconnect', function(){
            console.log('socket disconnected');
        });

        socket.on("AgencyMemberWasMentioned", function (data) {
          const parsedData = JSON.parse(data);
          const { mentioningAgencyMemberName, noteId, mentionId } = parsedData;

          if (!$rootScope.mentionesCount) {
            $rootScope.mentionesCount = 0;
          }
          $rootScope.mentionesCount += 1;

          notificationsService.notify(`${mentioningAgencyMemberName} tagged you in a note`, {
            actionOnClick: () => {
              const notificationToRemoveIndex = $rootScope.notifications.findIndex(
                (notification) => notification.mentionId === mentionId
              );
              if (notificationToRemoveIndex > -1) {
                $rootScope.notifications.splice(notificationToRemoveIndex, 1);
              }

              $rootScope.openNoteMention(noteId, mentionId);
            },
          });

          $rootScope.updateMentionsNotifications();
        });

        socket.on("CommCenterNotifyAgencyMember", (data) => {
            $rootScope.$broadcast("CommCenterNotifyAgencyMember", data);
        });

        socket.on("PortalPatientProfileUpdate", (data) => {
            $rootScope.$broadcast("PortalPatientProfileUpdate", data);
        });

        socket.on("PortalPatientDocumentUpload", (data) => {
            $rootScope.$broadcast("PortalPatientDocumentUpload", data);
        });
    }


    return {
        init: Consts.socketApi ? init : () => {
            console.log('`SOCKET_URL` not defined in server env vars: socket connection is disabled.');
        },
        on: function (eventName, callback) {}
    };
}

function safeJsonParse(json) {
  try {
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}
  